import React from "react";
import { Box, Grid } from "@material-ui/core";
import SimpleCard from "./SimpleCard";
import contact from "./Contact";
import { makeStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import IconButton from "@material-ui/core/IconButton";
import FavoriteIcon from "@material-ui/icons/Favorite";
import contacts from "./Contact";
const useStyles = makeStyles((theme) => ({
  root: { 
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    flexWrap: "nowrap",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)",
  },
  title: {
    color: "white",
    fontSize: 25,
    fontWeight: "bold",
    marginBottom:20
  },
  titleBar: {
    
    background:
      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
}));
export default function CardContent() {
  const classes = useStyles();
  return (
    <div>
      <Box display={{ xs: "none", md: "block" }}>
        <Grid container spacing={5}>
          {contact.map((props, index) => {
            return (
              <SimpleCard
                key={index}
                media={props.imgURL}
                name={props.name}
                ava={props.imgURL}
                descript={props.description}
              />
            );
          })}
        </Grid>
      </Box>
      <Box display={{ xs: "block", md: "none" }}>
        <GridList className={classes.gridList} cols={2.5}>
          {contacts.map((tile, index) => (
            <GridListTile style={{width:"80%", height:"50vh", margin:"-2"}} key={index}>
              <img  src={tile.imgURL} alt={tile.name} />
              <GridListTileBar
                title={tile.name}
                classes={{
                  root: classes.titleBar,
                  title: classes.title,
                }}
                actionIcon={
                  <IconButton aria-label={`star ${tile.title}`}>
                    <FavoriteIcon className={classes.title} />
                  </IconButton>
                }
              />
            </GridListTile>
          ))}
        </GridList>
      </Box>
    </div>
  );
}
